import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/burger.tsx
var Burger = ({ ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("rect", {
		x: "4",
		y: "8",
		width: "16",
		height: "2",
		rx: "1",
		fill: "currentColor"
	}), /* @__PURE__ */ jsx("rect", {
		x: "4",
		y: "14",
		width: "16",
		height: "2",
		rx: "1",
		fill: "currentColor"
	})] })
});
//#endregion
export { Burger };
